/// This function disables/re-enables the exact age section
/// when any of the age range checkboxes are checked
function ToggleAgeRange() {
    var tableBody = $('#ageRange').children(0);
    var questionMark = $('#lnkQuestion');
    var sensitiveFlag = $('.sensitiveFlag');
    var exactAgeFrom = $('#ExactAgeFrom');
    var exactAgeTo = $('#ExactAgeTo');
    var birthMonthYearFrom = $('#BirthMonthYearFrom');
    var birthMonthYearTo = $('#BirthMonthYearTo');
    var ButtonBirthMonthYearFrom = $('#MonthPicker_Button_BirthMonthYearFrom');
    var ButtonBirthMonthYearTo = $('#MonthPicker_Button_BirthMonthYearTo');

    var checked = $('#adultAgeContainer input:checked').length > 0;

    if (checked) {
        $(".age-code-ranges .SelectionBaseBoolCheckBox input:checkbox").removeAttr('disabled');
        exactAgeFrom.attr("disabled", "disabled");
        exactAgeTo.attr("disabled", "disabled");
        birthMonthYearFrom.attr("disabled", "disabled");
        birthMonthYearTo.attr("disabled", "disabled");
        ButtonBirthMonthYearFrom.css("pointer-events", "none");
        ButtonBirthMonthYearTo.css("pointer-events", "none");
        questionMark.attr("src", "/images/common/DisabledQuestionMark.gif");
        sensitiveFlag[1].src = "/images/common/DisabledSensitiveFlag.gif";
        exactAgeFrom.val("");
        exactAgeTo.val("");
        birthMonthYearFrom.val("");
        birthMonthYearTo.val("");
    } else {
        exactAgeFrom.removeAttr('disabled');
        exactAgeTo.removeAttr('disabled');
        birthMonthYearFrom.removeAttr('disabled');
        birthMonthYearTo.removeAttr('disabled');
        ButtonBirthMonthYearFrom.css("pointer-events", "auto");
        ButtonBirthMonthYearTo.css("pointer-events", "auto");
        questionMark.attr("src", "/images/common/QuestionMark.gif");
        sensitiveFlag[1].src = "/images/common/SensitiveFlag.gif";
    }
}

function ExactAgeSelected() {
    var questionMark = $('#lnkQuestion2');
    var sensitiveFlag = $('.sensitiveFlag');
    var exactAgeFrom = $('#ExactAgeFrom');
    var exactAgeTo = $('#ExactAgeTo');
    var birthMonthYearFrom = $('#BirthMonthYearFrom');
    var birthMonthYearTo = $('#BirthMonthYearTo');
    var ButtonBirthMonthYearFrom = $('#MonthPicker_Button_BirthMonthYearFrom');
    var ButtonBirthMonthYearTo = $('#MonthPicker_Button_BirthMonthYearTo');

    if (exactAgeFrom.val() == 0 || exactAgeTo.val() == 0 || exactAgeFrom.val() == "" || exactAgeTo.val() == "") {
        exactAgeFrom.removeAttr('disabled');
        exactAgeTo.removeAttr('disabled');
        birthMonthYearFrom.attr("disabled", "disabled");
        birthMonthYearTo.attr("disabled", "disabled");       
        ButtonBirthMonthYearFrom.css("pointer-events", "auto");
        ButtonBirthMonthYearTo.css("pointer-events", "auto");
        birthMonthYearFrom.val("");
        birthMonthYearTo.val("");
        $(".age-code-ranges .SelectionBaseBoolCheckBox input:checkbox").removeAttr('disabled');
        questionMark.attr("src", "/images/common/QuestionMark.gif");
        sensitiveFlag[0].src = "/images/common/SensitiveFlag.gif";
    } else {
        exactAgeFrom.removeAttr('disabled');
        exactAgeTo.removeAttr('disabled');
        birthMonthYearFrom.removeAttr('disabled');
        birthMonthYearTo.removeAttr('disabled');
        ButtonBirthMonthYearFrom.css("pointer-events", "none");
        ButtonBirthMonthYearTo.css("pointer-events", "none");
        $(".age-code-ranges .SelectionBaseBoolCheckBox input:checkbox").attr("disabled", "disabled");
        questionMark.attr("src", "/images/common/DisabledQuestionMark.gif");
        sensitiveFlag[0].src = "/images/common/DisabledSensitiveFlag.gif";
    }
}

function MonthYearSelected() {
    var questionMark = $('#lnkQuestion2');
    var sensitiveFlag = $('.sensitiveFlag');
    var exactAgeFrom = $('#ExactAgeFrom');
    var exactAgeTo = $('#ExactAgeTo');
    var birthMonthYearFrom = $('#BirthMonthYearFrom');
    var birthMonthYearTo = $('#BirthMonthYearTo');
   

    if (birthMonthYearFrom.val() == "" || birthMonthYearTo.val() == "") {
        exactAgeFrom.removeAttr('disabled');
        exactAgeTo.removeAttr('disabled');    
        exactAgeFrom.val("0");
        exactAgeTo.val("");
        $(".age-code-ranges .SelectionBaseBoolCheckBox input:checkbox").removeAttr('disabled');
        $(".birth-month-values .SelectionBaseBoolCheckBox input:checkbox").removeAttr('disabled');
        questionMark.attr("src", "/images/common/QuestionMark.gif");
        sensitiveFlag[0].src = "/images/common/SensitiveFlag.gif";
    } else {
        exactAgeFrom.attr("disabled", "disabled");
        exactAgeTo.attr("disabled", "disabled");       
        $(".age-code-ranges .SelectionBaseBoolCheckBox input:checkbox").attr("disabled", "disabled");
        $(".birth-month-values .SelectionBaseBoolCheckBox input:checkbox").attr("disabled", "disabled");
        questionMark.attr("src", "/images/common/DisabledQuestionMark.gif");
        sensitiveFlag[0].src = "/images/common/DisabledSensitiveFlag.gif";
    }
}
$(function () {
    $('body').delegate('.age-code-ranges input:checkbox', 'click', function (e) {
        ToggleAgeRange();
    });
});